module.exports = __webpack_public_path__ + "media/components/src/assets/images/image_text/10-a266ccc1cc2aaaf9cc4e61ff33f74fa9.jpg";